import { observer } from 'mobx-react-lite'
import { type FC } from 'react'
import classNames from 'classnames'
import { Button, type IButtonProps, Icon, type IStatusProps, Status, Typography } from 'shared/ui'
import styles from './styles.module.scss'

type IRegisterSectionItemProps = {
  id: number
  title: string
  desc: string
  statusProps?: IStatusProps | null
  actionIcon?: {
    onClick: (id: number) => void
  }
  actionButton?: IButtonProps
}

export const RegisterSectionItem: FC<IRegisterSectionItemProps> = observer(
  ({ id, title, desc, statusProps, actionIcon, actionButton }) => {
    const isBothButtons = actionButton && actionIcon

    return (
      <div
        className={classNames(styles.wrapItem, {
          [styles.clickableRegisterSectionItem]: actionIcon?.onClick,
        })}
        onClick={() => actionIcon?.onClick(id)}
      >
        <Typography ariaLabel='RegisterSection_title' variant={'body-md-medium'}>
          {title}
        </Typography>
        <Typography
          ariaLabel='RegisterSection_desc'
          variant='body-md-regular'
          color='var(--content-primary-tertiary)'
          className={styles.itemDesc}
          tag='div'
        >
          {desc}
        </Typography>
        {statusProps && (
          <div className={styles.status}>
            <Status {...statusProps} />
          </div>
        )}
        {actionIcon && (
          <>
            <div
              className={classNames(styles.arrowRight, {
                [styles.arrowRight_bothButtons]: isBothButtons,
              })}
            >
              {actionButton && (
                <Button
                  className={styles.registerBtn}
                  {...actionButton}
                  onClick={(e) => {
                    e.stopPropagation()
                    actionButton.onClick?.(e)
                  }}
                />
              )}
              <Icon
                ariaLabel='chevronRight'
                icon={'chevronRight'}
                color='var(--content-primary-tertiary)'
              />
            </div>
          </>
        )}
      </div>
    )
  }
)
